<div class="data-sync-error-dialog">
  <h2 mat-dialog-title>{{ "dataSyncAlertDialog.title" | translate }}</h2>
  <div mat-dialog-content>
    <div class="container" fxLayout="column" fxLayoutAlign="center center">
      <p>
        {{ "dataSyncAlertDialog.invalidDataMessage" | translate }}
      </p>
    </div>
    <br />
    <mat-list class="error-obj-list-contents">
      <mat-list-item *ngFor="let errorObj of offlineDataSyncErrorObjectList">
        <h3 matLine>{{ errorObj.inspectionSchema.title }}</h3>
        <p matLine *ngFor="let inspectionSchema of errorObj.inspectionImageSchemaList">
          <span> {{ inspectionSchema.fileName }} </span>
        </p>
        <p matLine *ngFor="let reportSchema of errorObj.individualReportSchemaList">
          <span> {{ reportSchema.fileName }} </span>
        </p>
      </mat-list-item>
    </mat-list>
  </div>

  <div mat-dialog-actions class="container" fxLayout="row" fxLayoutAlign="center center" position="fixed">
    <mat-dialog-actions>
      <button mat-raised-button color="primary" (click)="confirm()">{{ "dataSyncAlertDialog.close" | translate }}</button>
    </mat-dialog-actions>
  </div>
</div>
